import { Link } from "react-router-dom";
import { categories, topics } from "@/mocks/topics";

const icons: Record<string, string> = {
  带货风波: "ri-shopping-bag-3-line",
  直播争议: "ri-live-line",
  情感纠葛: "ri-heart-3-line",
  品牌翻车: "ri-flask-line",
  人设崩塌: "ri-user-unfollow-line",
  团队内讧: "ri-group-line",
};

export default function CategoryGrid() {
  const list = categories.filter((c) => c !== "全部");

  return (
    <section className="w-full border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="flex items-center gap-2 font-label text-xs font-medium tracking-[0.2em] text-accent-700">
            <i className="ri-price-tag-3-line"></i>
            主题分类
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            按事件类型翻找
          </h2>
          <p className="mt-3 font-label text-sm leading-relaxed text-foreground-600">
            同一类事件往往有相似的话术套路，放在一起翻找，更容易看出哪一方的说法前后不一致。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((name) => {
            const count = topics.filter((t) => t.category === name).length;
            const sumHeat = topics
              .filter((t) => t.category === name)
              .reduce((acc, t) => acc + t.heat, 0);
            return (
              <Link
                key={name}
                to={`/list?category=${encodeURIComponent(name)}`}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50"
              >
                <span className="flex h-12 w-12 flex-none items-center justify-center rounded-md bg-secondary-100 text-secondary-800 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                  <i className={`${icons[name] ?? "ri-file-list-3-line"} text-xl`}></i>
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block font-heading text-base font-semibold text-foreground-950">
                    {name}
                  </span>
                  <span className="mt-1 block font-label text-xs text-foreground-500">
                    {count} 个事件 · 累计热度 {sumHeat}
                  </span>
                </span>
                <i className="ri-arrow-right-line flex-none text-foreground-400 transition-transform group-hover:translate-x-1"></i>
              </Link>
            );
          })}

          <Link
            to="/list"
            className="flex items-center justify-center gap-2 rounded-lg border border-dashed border-background-300 bg-background-50 p-5 font-label text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-apps-2-line text-lg"></i>
            浏览全部归档
          </Link>
        </div>
      </div>
    </section>
  );
}